import { type KeywordOperandValue, OPERAND_TYPE_KEYWORD } from '@atlaskit/jql-ast';
import type { IntlShape } from '@atlassian/jira-intl';
import type {
	SearchTemplate,
	SelectOption,
} from '@atlassian/jira-jql-builder-basic-picker/src/common/types.tsx';
import { OperandValues, userFieldSearchTemplates } from '../../../../../../../common/constants.tsx';
import { getEmptyLabel } from '../../../../../../../utils/get-empty-label/index.tsx';

export const getKeywordValue = (
	value: KeywordOperandValue | 'empty',
	validOperandDisplayValues: undefined | Array<string>,
	intl: IntlShape,
	searchTemplate: SearchTemplate,
): SelectOption => {
	// EMPTY is the only supported RHS keyword in JQL (AST returns EMPTY for both EMPTY and NULL)
	const label = getEmptyLabel(searchTemplate ?? null, intl.formatMessage);
	const selectOptionValue = OperandValues.empty.value;

	const invalid =
		!validOperandDisplayValues ||
		!validOperandDisplayValues.some((keyword) => keyword.toLowerCase() === value.toLowerCase());

	if (searchTemplate && userFieldSearchTemplates.has(searchTemplate.toLowerCase())) {
		return {
			label,
			optionType: 'avatar',
			value: selectOptionValue,
			invalid,
			itemType: OPERAND_TYPE_KEYWORD,
		};
	}

	return {
		label,
		optionType: 'option',
		value: selectOptionValue,
		invalid,
		itemType: OPERAND_TYPE_KEYWORD,
	};
};
